import { Base } from '../../abstract/base.model';
import { CustomFieldTestType } from './custom-field-test-type.model';
import { FieldTestFile } from './field-test-file.model';
import { isRecord } from '../utils/is-record';
import { toFieldTestFiles } from '../utils/field-test-utils';
import { countOrZero, nullableBoolean, nullableString } from '../utils/wire-value-utils';

/**
 * A custom field test submission (an uploaded test document plus metadata), built from the hub's
 * submission JSON (`user-field-test-submissions-controller.ts`, hub `data-models/custom-field-test-submission.ts`).
 * `datePerformed` and `createdDate` are the hub's `createdAt` as sent (an ISO string).
 *
 * Read-modify-write rule: writable fields the hub didn't send stay `undefined` (an explicit `null` stays `null`).
 */
export class CustomFieldTest extends Base {
  // Writable fields (hub SUBMISSION_WRITABLE)
  title?: string | null;
  testType?: CustomFieldTestType | null;
  category?: string | null;
  description?: string | null;
  applicableAircraft?: string | null;
  frequency?: string | null;
  requiresSignoff?: boolean | null;

  // Read-only fields
  organizationId?: string | null;
  datePerformed?: string | null;
  createdDate?: string | null;
  files: FieldTestFile[];
  usageCount: number;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.title = nullableString(source['title']);
    this.testType = nullableString(source['testType']) as CustomFieldTestType | null | undefined;
    this.category = nullableString(source['category']);
    this.description = nullableString(source['description']);
    this.applicableAircraft = nullableString(source['applicableAircraft']);
    this.frequency = nullableString(source['frequency']);
    this.requiresSignoff = nullableBoolean(source['requiresSignoff']);
    this.organizationId = nullableString(source['organizationId']);
    this.datePerformed = nullableString(source['createdAt']);
    this.createdDate = nullableString(source['createdAt']);
    this.files = toFieldTestFiles(source['files']);
    this.usageCount = countOrZero(source['usageCount']);
  }
}
